import { Button } from '@components/button';
import { ButtonGroup } from '@components/button-group';
import { IconSend } from '@components/icons/send';
import { Stack } from '@components/stack';
import { Switch } from '@components/switch';
import { Text } from '@components/text';
import { TextField } from '@components/text-field';
import { getScopedTranslate } from '@locale/translate';

import { FieldDropzone } from './field-dropzone';

import { useFormBuilderContext } from '../context';
import { FieldEdit } from '../field-edit';
import { FieldConfig } from '../field-registry';
import { FieldSidebarLabel } from '../fields-sidebar';

type Config = FieldConfig<'submit'>;

const Display: Config['Display'] = ({ field }) => {
  const formVariant = useFormBuilderContext().store.useFormVariant();
  return (
    <ButtonGroup align="right">
      {formVariant === 'input' && !field.hideSaveButton && (
        <Button text={field.saveLabel} variant="primary-blue" />
      )}
      <Button text={field.label} variant="primary" />
    </ButtonGroup>
  );
};

const FormBuilderSubmit: Config['Component'] = ({ field }) => {
  const actions = useFormBuilderContext().store.actions;
  const formVariant = useFormBuilderContext().store.useFormVariant();

  return (
    <FieldDropzone field={field}>
      <FieldEdit
        field={field}
        display={<Display field={field} />}
        edit={
          <Stack space={4}>
            {formVariant === 'input' && (
              <TextField
                onChange={actions.createChangeHandler(field, 'saveLabel')}
                defaultValue={field.saveLabel}
                label={t('saveLabel')}
              />
            )}
            {formVariant === 'input' && (
              <Stack orientation="horizontal" justify="space-between" align="center">
                <Text font="regular14" text={t('displaySaveButton')} />
                <Switch
                  onChange={(val) => actions.createChangeHandler(field, 'hideSaveButton')(!val)}
                  defaultValue={!field.hideSaveButton}
                  labelVisible={false}
                  label={t('displaySaveButton')}
                />
              </Stack>
            )}
            <TextField
              onChange={actions.createChangeHandler(field, 'label')}
              defaultValue={field.label}
              label={t('submitLabel')}
            />
          </Stack>
        }
      />
    </FieldDropzone>
  );
};

const { t } = getScopedTranslate({
  en: {
    title: 'Buttons',
    saveLabel: 'Save button label',
    submitLabel: 'Submit button label',
    displaySaveButton: 'Display save button',
  },
});

export const submitConfig: Config = {
  kind: 'submit',
  title: t('title'),
  Component: FormBuilderSubmit,
  Display,
  TreeDisplay: () => <FieldSidebarLabel label={t('title')} />,
  Icon: IconSend,
  propertiesTabs: [],
};
